import {
  languageCodes,
  jobFamilyCamelCase,
  activityGroupCamelCase,
  ACTIVITY_GROUP,
  JOB_FAMILIES,
} from "config";

export const getActivityGroupByLanguage = (language, activityGroups) => {
  const allActivityGroups = activityGroups[language];
  if (allActivityGroups !== undefined) {
    return allActivityGroups;
  } else {
    return activityGroups[languageCodes.english];
  }
};

export const getJobFamiliesByLanguage = (language, jobFamilies) => {
  const allJobFamilies = jobFamilies[language];
  if (allJobFamilies !== undefined) {
    return allJobFamilies;
  } else {
    return jobFamilies[languageCodes.english];
  }
};

export const getTranslatedJobFamilyFromCamelCase = (
  camelCaseJobFamily,
  language
) => {
  const normalCaseJobFamily = jobFamilyCamelCase[camelCaseJobFamily];
  const jobFamilyOptions = getJobFamiliesByLanguage(language, JOB_FAMILIES);
  let translatedJobFamily = normalCaseJobFamily;

  jobFamilyOptions.forEach((jobFamilyObject) => {
    if (jobFamilyObject.value === normalCaseJobFamily) {
      translatedJobFamily = jobFamilyObject.label
        ? jobFamilyObject.label
        : normalCaseJobFamily;
    }
  });
  return translatedJobFamily;
};

export const getTranslatedActivityGroupFromCamelCase = (
  camelCaseActivityGroup,
  language
) => {
  const normalCaseActivityGroup =
    activityGroupCamelCase[camelCaseActivityGroup];
  const activityGroupOptions = getActivityGroupByLanguage(
    language,
    ACTIVITY_GROUP
  );
  let translatedActivityGroup = normalCaseActivityGroup;

  activityGroupOptions.forEach((activityGroupObject) => {
    if (activityGroupObject.value === normalCaseActivityGroup) {
      translatedActivityGroup = activityGroupObject.label
        ? activityGroupObject.label
        : normalCaseActivityGroup;
    }
  });

  return translatedActivityGroup;
};

export const barChartColors = {
  project: "#6DCFF6",
  transactional: "#1B75BC",
  nonTransactional: "#00A88E",
  buildingMoves: "#3C5772",
};

export const convertCamelToNormalCase = (string) => {
  const result = string.replace(/([A-Z])/g, " $1");
  const finalResult = result.charAt(0).toUpperCase() + result.slice(1);

  return finalResult;
};
